<template>
  <FormContainer
    level="chapter"
    :level-number="chapter.chapter_number"
    button-text="commencer"
    :title="chapter.name"
    :hide-button="hideButton"
    :hide-content="isSectionOpen"
    @click="startChapter"
  >
    <EntityImgContainer
      v-if="chapter.image"
      class="col-12 col-md-6 ps-0 pb-3"
      :alt="chapter.name"
      :img-url="chapter.image"
    />
    <div
      :class="chapter.image ? 'col-md-6' : 'col-md-12'"
      class="col-12 pe-0 py-3 text-secondary"
    >
      <p style="text-align: justify">{{ chapter.description }}</p>
    </div>
  </FormContainer>
</template>

<script>
import EntityImgContainer from '../EntityImgContainer.vue'
import FormContainer from './FormContainer.vue'
export default {
  components: { FormContainer, EntityImgContainer },
  props: {
    chapter: {
      type: Object,
      required: true,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    isSectionOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sections() {
      return this.chapter.sections.reduce((map, section) => {
        return map.set(section.display_order, section)
      }, new Map())
    },
    firstSection() {
      return this.sections.values().next().value
    },
    selectedSection() {
      return this.chapterId
        ? this.survey.get(this.chapterId)
        : this.firstSection
    },
  },
  methods: {
    startChapter() {
      this.$emit('start', this.selectedSection.display_order)
    },
  },
}
</script>
